import React from 'react'
import st from './AddingFunnels.module.scss'
import { ReactComponent as InfoIcon } from 'components/CRM/UI/icons/infoSquare.svg'
import asideModalStore from 'Stores/asideModalStore'
import { HeaderButton } from 'components/UI/SuperButton/SuperButton'
import AddingFunnelsModal from './AddingFunnelsModal'
import { observer } from 'mobx-react'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import useLocalization from 'hooks/useLocalization'

const AddingFunnels = ({ executors, isAddingDisable, addFunnel }) => {
  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'crm_settings',
    dict: {
      adding_funnels: 'Adding funnels',
      add_funnel: 'Add funnel',
      max_funnels: 'Maximum number of funnels: 5',
      save: 'Save',
    },
  })

  const CreateFunnelModal = () => {
    const ms = {
      modalBodyComponent: () => <AddingFunnelsModal options={executors} />,
      button: translate.save,
      link: 'integration/funnels',
      title: translate.add_funnel,
      crm: true,
      onSubmitSuccess: (res) => {
        addFunnel(res)
      },
      isResponsive: true,
      valid: {
        name: 'required',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }
  return (
    <div className={st.container}>
      <div className={st.addingContainer}>
        <PageHeader title={translate.adding_funnels}></PageHeader>
        <HeaderButton
          disabled={isAddingDisable}
          title={translate.add_funnel}
          onClick={() => CreateFunnelModal()}
        />
      </div>

      {isAddingDisable && (
        <div className={st.descriptions}>
          <InfoIcon />
          <div className={st.text}>{translate.max_funnels}</div>
        </div>
      )}
    </div>
  )
}
export default observer(AddingFunnels)
